<template>
    <div>
        <app-nav></app-nav>
        <div class="container-fluid">
            <div class="col-2"></div>
             <div class="col-10">
            <div class="row">

                    <h5 class="text-left">Nouveau collègue !</h5>
            </div>
                    <div class="row">
                        <form v-on:submit.prevent class="titulaire-form">
                            <div class="form-group row ">
                                <label for="nom" class="col-4 control-label"> Nom</label>
                                <div class="col-7">
                                    <input autofocus required v-model.trim ="nomTitulaire" placeholder="Nom" autocomplete="off" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group row ">
                                <label for="prenom" class="col-4 control-label">Prénom</label>
                                <div class="col-7">
                                    <input v-model.trim ="prenomTitulaire" class="form-control" placeholder="Prénom" autocomplete="off" type="text" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="sel" class="col-4 control-label">SEL</label>
                                <div class="col-7">
                                    <input v-model.trim ="sel" name="sel" type="text" class="form-control" placeholder="nom de la SEL" value=sel />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="numsel" class="col-4 control-label"> N° de SEL</label>
                                <div class="col-7">
                                    <input v-model.trim ="numsel" name="numsel" type="text" class="form-control" placeholder="numéro de la SEL" value=numsel />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="ordre" class="col-4 control-label"> Num. conseil de l'ordre</label>
                                <div class="col-7">
                                    <input name="ordre" type="text" class="form-control" placeholder="Num. conseil de l'ordre" v-model.trim ="ordre" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="adeli" class="col-4 control-label"> Num. adeli</label>
                                <div class="col-7">
                                    <input name="adeli" type="text" class="form-control" placeholder="Num. adeli" v-model.trim ="adeli" />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="rpps" class="col-4 control-label"> RPPS</label>
                                <div class="col-7">
                                    <input name="rpps" type="text" class="form-control" placeholder="RPPS" v-model.trim ="rpps" />
                                </div>
                            </div>
                            <button class="btn btn-primary" type="submit" @click="addTitulaire">Valider</button>
                        </form>
                    </div>
             </div>
        </div>
    </div>
</template>
<script>
import AppNav from './AppNav'
import {
  ALL_TITULAIRES_QUERY,
  CREATE_TITULAIRE
} from '../constants/graphql'

export default {
  name: 'titulaires-new',
  components: {
    AppNav
  },
  data () {
    return {
      nomTitulaire: null,
      prenomTitulaire: null,
      sel: null,
      numsel: null,
      adeli: "",
      ordre: "",
      rpps: ""
    }
  },
  methods: {
    addTitulaire () {
      const nomTitulaire = this.nomTitulaire
      const prenomTitulaire = this.prenomTitulaire
      const sel = this.sel
      const numsel = this.numsel
      const adeli = this.adeli
      const ordre = this.ordre
      const rpps = this.rpps
      var self = this
      this.$apollo.mutate({
        mutation: CREATE_TITULAIRE,
        variables: {
          nom: this.nomTitulaire,
          prenom: this.prenomTitulaire,
          sel: this.sel,
          numsel: this.numsel,
          adeli: this.adeli,
          ordre: this.ordre,
          rpps: this.rpps,
          retraite: false
          },
        refetchQueries: [{
          query: ALL_TITULAIRES_QUERY
        }]  
      }).then((data) => {
          // Result
        this.nomTitulaire = ''
        this.prenomTitulaire = ''
        this.sel = ''
        this.numsel = ''
        this.adeli = ''
        this.ordre = ''
        this.rpps = ''
        self.$router.push({name: 'Titulaires'})
      }).catch((error) => {
        console.error(error)
          // We restore the initial user input
        this.nomTitulaire = nomTitulaire
        this.prenomTitulaire = prenomTitulaire
        this.sel = sel
        this.numsel = numsel
        this.adeli = adeli
        this.ordre = ordre
        this.rpps =  rpps
      })
    }
  }
}
</script>
<style scoped>
body {
    padding-top: 3.5rem;  
}

h1 {
    margin-bottom: 20px;
    padding-bottom: 9px;
    border-bottom: 1px solid #eee;
}

.sidebar {
    position: fixed;
    top: 51px;
    bottom: 0;
    left: 0;
    z-index: 1000;
    padding: 20px;
    overflow-x: hidden;
    overflow-y: auto;
    /* Scrollable contents if viewport is shorter than content. */
    border-right: 1px solid #eee;
}
/* Sidebar navigation */

.sidebar {
    padding-left: 0;
    padding-right: 0;
}

.sidebar .nav {
    margin-bottom: 20px;
}

.sidebar .nav-item {
    width: 100%;
}

.sidebar .nav-item+.nav-item {
    margin-left: 0;
}

.sidebar .nav-link {
    border-radius: 0;
}

.placeholders {
    padding-bottom: 3rem;
}

.placeholder img {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

select option[data-default] {
    display: none;
}

.medecins-form{
    padding-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// titulairesNew.vue?0b9b8192